import type { TimePeriod } from './bookings'
import type { HuntType } from './hunt-type'
import type { SchedulableLocationType } from './schedule'
import type { TimeBlock, TimeBlockPeriod } from './time-block'
import { TIME_BLOCK_PERIOD_LABELS } from './time-block'

export type TimeBlockLookup = {
  locationType: SchedulableLocationType
  locationId: string
}

export type TimeBlockLabelQuery = {
  huntType?: HuntType
  timePeriod?: TimePeriod
  scope: TimeBlockLookup | null
}

export type ResolveTimeBlockLabel = (query: TimeBlockLabelQuery) => string | null

const ORG_SCOPE_KEY = 'org'

export function timeBlockScopeKey(scope: TimeBlockLookup | null): string {
  return scope ? `${scope.locationType}:${scope.locationId}` : ORG_SCOPE_KEY
}

export function findTimeBlock(
  blocks: TimeBlock[],
  huntType: HuntType | undefined,
  timePeriod: TimePeriod | undefined,
): TimeBlock | undefined {
  if (!huntType || !timePeriod) return undefined
  return blocks.find((block) => block.huntType === huntType && block.timePeriod === timePeriod)
}

export const DEFAULT_TIME_BLOCK_HOURS: Record<TimeBlockPeriod, { startTime: string; endTime: string }> = {
  am: { startTime: '05:00', endTime: '10:00' },
  midday: { startTime: '10:00', endTime: '14:00' },
  pm: { startTime: '14:00', endTime: '19:00' },
  'all-day': { startTime: '05:00', endTime: '19:00' },
}

export type DefaultTimeBlock = Pick<TimeBlock, 'name' | 'startTime' | 'endTime'>

export function defaultTimeBlock(timePeriod: TimePeriod | undefined): DefaultTimeBlock | undefined {
  if (!timePeriod || timePeriod === 'night') return undefined
  return { name: TIME_BLOCK_PERIOD_LABELS[timePeriod], ...DEFAULT_TIME_BLOCK_HOURS[timePeriod] }
}
